import React from "react";
import { useLocation } from "react-router-dom";
import { useRecruitment } from "../../../../context/RecruitmentContext";
import { findCampaignById } from "../../../../utils/constants/config";
import MobileCandidateModal from "./MobileCandidateModal";

const resolveCampaignIdFromPath = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0 || segments[0] === "chat") return null;
  if (segments.length === 2 && ["chat", "apply"].includes(segments[1])) {
    return segments[0];
  }
  if (segments.length === 1) return segments[0];
  return null;
};

const MobileRecruitmentModals = () => {
  const { pathname } = useLocation();
  const {
    campaigns,
    candidateModalOpen,
    candidateModalShowCv,
    closeCandidateModal,
    modalCampaignId,
  } = useRecruitment();

  const activeId = modalCampaignId || resolveCampaignIdFromPath(pathname);
  const campaign = findCampaignById(campaigns, activeId);
  const targetPath = activeId ? `/${activeId}` : "/chat";

  return (
    <MobileCandidateModal
      open={candidateModalOpen}
      onClose={closeCandidateModal}
      campaignTitle={campaign?.title || ""}
      campaign={campaign}
      campaignId={activeId}
      showCvUpload={candidateModalShowCv}
      targetPath={targetPath}
    />
  );
};

export default MobileRecruitmentModals;
